export const Home = {
    Active: () => (
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
            <mask id="mask0_1599_65108" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="15">
                <path fillRule="evenodd" clipRule="evenodd" d="M0 0H14.2394V14.9714H0V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1599_65108)">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.97965 14.9714H5.25978V10.2172C5.25978 9.70836 5.67223 9.2959 6.1811 9.2959H8.05833C8.56715 9.2959 8.97965 9.70836 8.97965 10.2172V14.9714ZM6.53958 0.205565L0.341208 5.22926C0.125351 5.4042 0 5.66721 0 5.945V7.10489V7.4841V14.0501C0 14.5589 0.4125 14.9714 0.92132 14.9714H13.3181C13.8269 14.9714 14.2394 14.5589 14.2394 14.0501V7.4841V7.10489V5.945C14.2394 5.66721 14.114 5.4042 13.8982 5.22926L7.6998 0.205565C7.36163 -0.0685218 6.87779 -0.0685218 6.53958 0.205565V0.205565Z" fill="#4739E7" />
            </g>
        </svg>
    ),
    Inactive: () => (
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
            <mask id="mask0_1599_65108" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="15">
                <path fillRule="evenodd" clipRule="evenodd" d="M0 0H14.2394V14.9714H0V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1599_65108)">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.97965 14.9714H5.25978V10.2172C5.25978 9.70836 5.67223 9.2959 6.1811 9.2959H8.05833C8.56715 9.2959 8.97965 9.70836 8.97965 10.2172V14.9714ZM6.53958 0.205565L0.341208 5.22926C0.125351 5.4042 0 5.66721 0 5.945V7.10489V7.4841V14.0501C0 14.5589 0.4125 14.9714 0.92132 14.9714H13.3181C13.8269 14.9714 14.2394 14.5589 14.2394 14.0501V7.4841V7.10489V5.945C14.2394 5.66721 14.114 5.4042 13.8982 5.22926L7.6998 0.205565C7.36163 -0.0685218 6.87779 -0.0685218 6.53958 0.205565V0.205565Z" fill="#74748A" />
            </g>
        </svg >
    )
};

export const Schedule = {
    Active: () => (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" fill="#4739E7" stroke="#4739E7" />
            <path d="M7.98901 3.82642V8.022L9.51267 9.54566" stroke="#FCFBFC" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    Inactive: () => (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#74748A" />
            <path d="M7.98901 3.82617V8.02176L9.51267 9.54541" stroke="#74748A" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
};

export const Templates = {
    Active: () => (
        <svg width="22" height="17" viewBox="0 0 22 17" fill="none">
            <path d="M12 8H19V9.5H12V8ZM12 5.5H19V7H12V5.5ZM12 10.5H19V12H12V10.5ZM20 0H2C0.9 0 0 0.9 0 2V15C0 16.1 0.9 17 2 17H20C21.1 17 22 16.1 22 15V2C22 0.9 21.1 0 20 0ZM20 15H11V2H20V15Z" fill="#4739E7" />
        </svg>
    ),
    Inactive: () => (
        <svg width="22" height="17" viewBox="0 0 22 17" fill="none">
            <path d="M12 8H19V9.5H12V8ZM12 5.5H19V7H12V5.5ZM12 10.5H19V12H12V10.5ZM20 0H2C0.9 0 0 0.9 0 2V15C0 16.1 0.9 17 2 17H20C21.1 17 22 16.1 22 15V2C22 0.9 21.1 0 20 0ZM20 15H11V2H20V15Z" fill="#74748A" />
        </svg>
    )
};
